var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_990_25210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 9.88219V16.9411H22.5881V19.7648H21.1763V21.1763H19.7648V22.5881H16.9411V24H9.88219V22.5881H7.05891V21.1763H5.64703V19.7648H4.23516V16.9411H2.82375V12.7059H4.23516V11.2941H2.82375V9.88219H1.41188V8.47078H0V2.82375H1.41188V1.41188H2.82375V0H9.88219V1.41188H11.2941V2.82375H16.9411V4.23516H19.7648V5.64703H21.1763V7.05891H22.5881V9.88219H24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2941 2.8241V8.47113H9.88218V9.88254H8.47077V11.2944H7.0589L6.35296 12.0004L5.64702 11.2944H4.23515V9.88254H2.82374V8.47113H1.41187V2.8241H2.82374L3.37176 2.11816H9.33416L9.88218 2.8241H11.2941Z",
    fill: "#FF3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3529 7.05848V8.47035H16.941V11.2936H15.5291V12.7055H14.1177V14.1174H15.5291V15.5288H16.941V16.9407H15.5291V19.7644H11.294V18.3525H12.7059V16.9407H11.294V15.5288H8.47071V14.1174L7.76477 13.4114L8.47071 12.7055L9.88211 11.2936L11.294 9.88176L11.9997 9.17605L12.7059 9.88176H14.1177V8.47035H15.5291V7.05848H16.941L17.647 6.35254L18.3529 7.05848Z",
    fill: "#2FBFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5293 7.05922H14.1179V8.47109H12.706V5.64734L13.4119 4.94141H15.5293V7.05922Z",
    fill: "#B3D141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5882 9.88188V16.9408H21.1763V19.7645H19.7649L16.9412 21.1759L16.2352 21.8819L15.5293 21.1759V19.7645H16.9412V16.9408H18.353V15.5289H16.9412V14.1175H15.5293V12.7056H16.9412V11.2938H18.353V8.47047H19.7649V7.05859H21.1763V9.88188H22.5882Z",
    fill: "#B3D141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2941 16.9413V18.3532H9.88226V19.7651L9.17656 20.4708H7.76492L7.05898 19.7651H5.6471V16.9413H4.23523V14.118L4.94117 13.4121L5.6471 14.118L7.05898 15.5295H8.47085V16.9413H11.2941Z",
    fill: "#B3D141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.294 8.4707H12.7059V9.88211H11.294V8.4707Z",
    fill: "#0D90BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88214 9.88184H11.294V11.2937H9.88214V9.88184Z",
    fill: "#0D90BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4707 11.2939H9.88211V12.7058H8.4707V11.2939Z",
    fill: "#0D90BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05884 12.7061H8.47071V14.1179H7.05884V12.7061Z",
    fill: "#0D90BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64703 11.2939H7.05891V12.7058H5.64703V11.2939Z",
    fill: "#C8001C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88217 5.64724V7.05912H8.47076V8.47099H7.05889L6.35295 9.1767L5.64701 8.47099H4.23514V7.05912H2.82373V5.64724H4.23514V4.23537H5.64701V2.11816H7.05889V4.23537H8.47076V5.64724H9.88217Z",
    fill: "#007745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88226 21.1768H16.9412V22.5886H9.88226V21.1768Z",
    fill: "#58B354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23517 12.7061H5.64704V14.1179H4.23517V12.7061Z",
    fill: "#58B354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64709 14.1182H7.05897V15.5296H5.64709V14.1182Z",
    fill: "#58B354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05896 19.7646H9.88224V21.1761H7.05896V19.7646Z",
    fill: "#58B354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9412 19.7646H19.7649V21.1761H16.9412V19.7646Z",
    fill: "#58B354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47085 5.64734V7.05922H4.23523V5.64734H5.6471L6.35304 4.94141L7.05898 5.64734H8.47085Z",
    fill: "#B3D141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64703 8.4707H7.05891V9.88211H5.64703V8.4707Z",
    fill: "#8E4813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82373 1.41211H9.88217V2.82398H2.82373V1.41211Z",
    fill: "#FFA07B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64703 4.23535H7.05891V5.64723H5.64703V4.23535Z",
    fill: "#EFEFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9412 5.64746H19.7649V7.05934H16.9412V5.64746Z",
    fill: "#BCFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7059 4.23535H16.9411V5.64723H12.7059V4.23535Z",
    fill: "#EFEFA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_990_25210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.740efed3c85664ffd66a972739909d69.svg";
export { ForwardRef as ReactComponent };